import videoPosters from '../../config/video-posters.json';

const POSTER_METADATA: Readonly<Record<string, { width: number; height: number }>> = videoPosters;

/** Соотношение сторон самого ролика: у Shorts размер обложки может включать боковые вставки. */
export const getVideoAspectRatio = (src: string | undefined): number | undefined => {
  const id = src && /rutube\.ru\/play\/embed\/([0-9a-f]{32})/.exec(src)?.[1];
  const size = id ? POSTER_METADATA[id] : undefined;
  return size ? size.width / size.height : undefined;
};
